module.exports = __webpack_public_path__ + "img/4-1.902af5f2.png";